module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_IMMUNSYSTEM.87db5b97.png";